import React from "react";
import { BtnLikePost } from "@/components/Community/LikeBtn";
import Link from "next/link";
import Image from "next/image";
import IconSeek from "@/images/iconSeek.svg";
import IconShare from "@/images/iconShare.svg";
import Avatar from "react-avatar";
import moment from "moment";
import { useRouter } from "next/router";

export default function PostCard(props) {
  const post = props.post;
  const user = props.user;
  const router = useRouter();

  const handleUserRoute = () => {
    router.push(`/u/${user.username}`);
  };
  return (
    <div className="flex-fill w-full">
      <div className="px-0 bg-transparent mb-2">
        <div className="d-flex gap-3 align-items-start">
          <BtnLikePost
            style={{ width: "50px" }}
            className=" py-2 mds-like-btn mds-fs-5 btn mds-btn mds-btn-outline-primary-light align-items-center d-flex flex-column gap-1"
            post={post}
          />
          <div className="d-flex flex-column gap-2 flex-fill">
            <Link href={`/community/posts/${post.slug}`}>
              <a>
                <h5 className="text-capitalize w-100 m-0 mds-text-dark">
                  {post.title.slice(0, 50)}
                  {post.title.length > 50 && "..."}
                </h5>
              </a>
            </Link>
            <div className="d-flex gap-3 d-lg-none">
              <div className="d-flex gap-2 align-items-center">
                {post.postType === "seek" ? (
                  <Image layout="fixed" width={25} height={25} src={IconSeek} />
                ) : (
                  <Image
                    layout="fixed"
                    width={25}
                    height={25}
                    src={IconShare}
                  />
                )}

                <span className="mds-fs-5 mds-fw-md">{post.postType}</span>
              </div>
            </div>
            <p className="fw-light m-0">
              {typeof post.body === "object" ? (
                post.body?.content[0].content.map((itemContent) => {
                  return (
                    <>
                      {itemContent.type === "text" ? (
                        <span>
                          {itemContent.text.slice(0, 70)}{" "}
                          {itemContent.text.length > 70 && "..."}
                        </span>
                      ) : (
                        <Link href={`/company/${itemContent.attrs.id.slug}`}>
                          <a className="mds-text-primary text-capitalize">
                            @{itemContent.attrs.id.companyName}
                          </a>
                        </Link>
                      )}
                    </>
                  );
                })
              ) : (
                <>
                  <span>{post.body}</span>
                </>
              )}
            </p>
            <div className="d-flex justify-content-between align-items-center gap-3">
              <div className="d-flex align-items-center gap-3">
                <div className="d-flex gap-2 align-items-center">
                  {user.imageUrl ? (
                    <Image
                      layout="fixed"
                      className="border mds-border-primary-light rounded-circle"
                      src={post.userId.imageUrl}
                      width={16}
                      height={16}
                    />
                  ) : (
                    <Avatar name={user.fullName} size={16} round />
                  )}{" "}
                  <span
                    onClick={handleUserRoute}
                    style={{ cursor: "pointer" }}
                    className="mds-fs-5 text-capitalize mds-fw-md text-nowrap mds-text-primary"
                  >
                    {user.fullName}
                  </span>
                </div>
                <div className="d-flex gap-1 align-items-center d-none d-lg-inline-flex">
                  {post.postType === "seek" ? (
                    <Image
                      layout="fixed"
                      width={16}
                      height={16}
                      src={IconSeek}
                    />
                  ) : (
                    <Image
                      layout="fixed"
                      width={16}
                      height={16}
                      src={IconShare}
                    />
                  )}

                  <span className="mds-fs-5 mds-fw-md">{post.postType}</span>
                </div>
              </div>
              <div className="d-flex align-items-center gap-3">
                <div className="d-flex gap-1 align-items-center">
                  <div className="d-flex align-items-center "></div>
                  <div>
                    <Link href={`/community/posts/${post.slug}#post-replies`}>
                      <a className="mds-fs-5 mds-fw-md text-nowrap mds-text-primary">
                        {post.countReplies + " Replies"}
                      </a>
                    </Link>
                  </div>
                </div>
                <div className="mds-fs-5 mds-fw-md text-muted text-nowrap d-none d-lg-inline-flex">
                  {moment(post.createdAt).fromNow("ll")} ago
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
